import { render } from "./MedicationMasters.vue?vue&type=template&id=3ef3d200"
import script from "./MedicationMasters.vue?vue&type=script&lang=js"
export * from "./MedicationMasters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__